import { UserState } from "@/vuex/modules/user/user.types";

export const state: UserState = {
  users: [],
  loading: false,
  error: false,
  currentTill: null
};
